import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { ReadSpeakerService } from '../../../services/readspeaker.service';
import { WordingPipe } from '../../../pipes/wording/wording.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'shared-toggle-read-speaker-visibility',
  templateUrl: './toggle-read-speaker-visibility.component.html',
  styleUrls: ['./toggle-read-speaker-visibility.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTooltipModule, AsyncPipe, WordingPipe],
})
export class ToggleReadSpeakerVisibilityComponent implements OnInit {
  private _readSpeakerService = inject(ReadSpeakerService);
  private _cdr = inject(ChangeDetectorRef);
  hasAccess$ = this._readSpeakerService.hasAccess$;
  isVisible = false;

  toggleReadSpeakerVisibility(): void {
    this._readSpeakerService.toggleVisibility();
  }

  ngOnInit(): void {
    this._readSpeakerService.visibility$.subscribe(val => {
      this.isVisible = val;
      this._cdr.detectChanges();
    });
  }
}
